import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  artworkInfoWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
  },
  artworkTitle: {
    fontSize: 16,
    lineHeight: '24px',
  },
  artworkArtist: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#737373',
  },
  image: {
    width: '20%',
  },
}));

export default useStyles;
